/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { APPLICATION_VIEW_OFFICE } from '@gh/builder-shared-data';

import { createRoute } from '@gh/common-shared';
import {
  JobCsDetailsBusinessService,
  JobCsDetailsComponent,
  JobEstimateDetailsBusinessService,
  JobEstimateDetailsComponent,
  JobListBusinessService,
  JobListComponent, JobOrderDetailsBusinessService, JobOrderDetailsListBusinessService,
  JobOrderListBusinessService,
  JobOrderListComponent,
  JobQuickDetailsComponent,
} from './jobs';
import { JobCoDetailsComponent } from './jobs/components/job-co-details/job-co-details.component';
import { JobCoListComponent } from './jobs/components/job-co-list/job-co-list.component';
import { JobDetailsCommunicationListTabComponent } from './jobs/components/job-details-tab-container/job-details-communication-list-tab/job-details-communication-list-tab.component';
import { JobDetailsDatesTabComponent } from './jobs/components/job-details-tab-container/job-details-dates-tab/job-details-dates-tab.component';
import { JobDetailsDrawsTabComponent, JobDrawDetailsTabBusinessService } from '@gh/builder-shared';
import { JobDetailsEDocsTabComponent } from './jobs/components/job-details-tab-container/job-details-edocs-tab/job-details-e-docs-tab.component';
import { JobDetailsGeneralTabComponent } from './jobs/components/job-details-tab-container/job-details-general-tab/job-details-general-tab.component';
import { JobDetailsInsuranceTabComponent } from './jobs/components/job-details-tab-container/job-details-insurance-tab/job-details-insurance-tab.component';
import { JobDetailsLetterListTabComponent } from './jobs/components/job-details-tab-container/job-details-letter-list-tab/job-details-letter-list-tab.component';
import { JobDetailsRfqTabComponent } from './jobs/components/job-details-tab-container/job-details-rfq-tab/job-details-rfq-tab.component';
import { JobDetailsSharedDocListTabComponent } from './jobs/components/job-details-tab-container/job-details-shared-doc-list-tab/job-details-shared-doc-list-tab.component';
import { JobDetailsTabContainerComponent } from './jobs/components/job-details-tab-container/job-details-tab-container.component';
import { JobDetailsVariationListTabComponent } from './jobs/components/job-details-tab-container/job-details-variation-list-tab/job-details-variation-list-tab.component';
import { JobDetailsWarrantyTabComponent } from './jobs/components/job-details-tab-container/job-details-warranty-task-list-tab/job-details-warranty-task-list-tab.component';
import { JobDppDetailsContainerComponent } from './jobs/components/job-dpp-details-container/job-dpp-details-container.component';
import { JobFinancialsComponent } from './jobs/components/job-financials/job-financials.component';
import { JobSpecDetailsComponent } from './jobs/components/job-spec-details/job-spec-details.component';
import { JobCoDetailsBusinessService } from './jobs/resources/job-co-details-business.service';
import { JobCoListBusinessService } from './jobs/resources/job-co-list-business.service';
import { JobDetailsTabBusinessService } from './jobs/resources/job-details-tab/job-details-tab-business.service';
import { JobDPPBusinessService } from './jobs/resources/job-dpp-business.service';
import { JobFinancialsBusinessService } from './jobs/resources/job-financials-business.service';
import { JobSpecBusinessService } from './jobs/resources/job-spec-business.service';
import { JobCoJobListComponent } from './jobs/components/job-co-job-list/job-co-job-list.component';
import { JobCoJobListBusinessService } from './jobs/resources/job-co-job-list-business.service';
import { JobOrderDetailsComponent } from './jobs/components/job-order-details/job-order-details.component';
import { JobFinancialsListComponent } from './jobs/components/job-financials-list/job-financials-list.component';
import { JobFinancialsListBusinessService } from './jobs/resources/job-financials-list-business.service';
import { JobSpecListComponent } from './jobs/components/job-spec-list/job-spec-list.component';
import { JobSpecListBusinessService } from './jobs/resources/job-spec-list-business.service';
import { JobColorSelectionListComponent } from './jobs/components/job-color-selection-list/job-color-selection-list.component';
import { JobCsListBusinessService } from './jobs/resources/job-cs-list-business.service';
import {
  JobDppDetailsGeneralTabComponent,
} from './jobs/components/job-dpp-details-container/job-dpp-details-general-tab/job-dpp-details-general-tab.component';
import {
  JobDppDetailsLetterListTabComponent,
} from './jobs/components/job-dpp-details-container/job-dpp-details-letter-list-tab/job-dpp-details-letter-list-tab.component';
import {
  JobDppDetailsCommunicationListTabComponent,
// tslint:disable-next-line:max-line-length
} from './jobs/components/job-dpp-details-container/job-dpp-details-communication-list-tab/job-dpp-details-communication-list-tab.component';
import {
  JobDetailsChecklistsTabComponent,
} from './jobs/components/job-details-tab-container/job-details-checklists-tab/job-details-checklists-tab.component';
import {
  JobDppDetailsChecklistsTabComponent,
} from './jobs/components/job-dpp-details-container/job-dpp-details-checklists-tab/job-dpp-details-checklists-tab.component';

const routes: Routes = [
  createRoute({
    path: 'jobs',
    component: JobListComponent,
    init: JobListBusinessService,
    auth: {
      permission: 'JobAdmin.Jobs.LIST',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'job-specifications',
    component: JobSpecListComponent,
    init: JobSpecListBusinessService,
    auth: {
      permission: 'JobAdmin.JobSpecifications.LIST',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'jobs/:jobId',
    component: JobDetailsTabContainerComponent,
    init: JobDetailsTabBusinessService,
    auth: {
      permission: 'JobAdmin.JobDetails.ANY',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
    children: [
      createRoute({
        component: JobDetailsGeneralTabComponent,
        leave: true,
        path: 'general',
        init: {
          service: JobDetailsTabBusinessService,
          selector: 'initGeneralTabView',
        },
      }),
      createRoute({
        component: JobDetailsDatesTabComponent,
        path: 'dates',
        leave: true,
        init: {
          service: JobDetailsTabBusinessService,
          selector: 'initDatesTabView',
        },
      }),
      createRoute({
        component: JobDetailsRfqTabComponent,
        path: 'rfq',
        init: {
          service: JobDetailsTabBusinessService,
          selector: 'initRfqTabView',
        },
      }),
      createRoute({
        component: JobDetailsLetterListTabComponent,
        path: 'letters',
        init: {
          service: JobDetailsTabBusinessService,
          selector: 'initLettersDocsTabView',
        },
      }),
      createRoute({
        component: JobDetailsEDocsTabComponent,
        path: 'edocs',
        init: {
          service: JobDetailsTabBusinessService,
          selector: 'initEdocsTabView',
        },
      }),
      createRoute({
        component: JobDetailsDrawsTabComponent,
        path: 'draws',
        leave: true,
        init: {
          service: JobDrawDetailsTabBusinessService,
          selector: 'initDrawsTabView',
        },
      }),
      createRoute({
        component: JobDetailsVariationListTabComponent,
        path: 'variations',
        init: {
          service: JobDetailsTabBusinessService,
          selector: 'initVariationListTabView',
        },
      }),
      createRoute({
        component: JobDetailsInsuranceTabComponent,
        path: 'insurance',
        leave: true,
        init: {
          service: JobDetailsTabBusinessService,
          selector: 'initInsuranceTabView',
        },
      }),
      createRoute({
        component: JobDetailsCommunicationListTabComponent,
        path: 'communications',
        init: {
          service: JobDetailsTabBusinessService,
          selector: 'initCommunicationListTabView',
        },
      }),
      createRoute({
        component: JobDetailsWarrantyTabComponent,
        path: 'warranty',
        init: {
          service: JobDetailsTabBusinessService,
          selector: 'initWarrantyTabView',
        },
      }),
      createRoute({
        component: JobDetailsSharedDocListTabComponent,
        path: 'shared-docs',
        init: {
          service: JobDetailsTabBusinessService,
          selector: 'initSharedDocTabView',
        },
      }),
      createRoute({
        component: JobDetailsChecklistsTabComponent,
        path: 'checklists',
        init: {
          service: JobDetailsTabBusinessService,
          selector: 'initChecklistsTabView',
        },
      }),
    ],
  }),
  createRoute({
    path: 'jobs/quick/new',
    component: JobQuickDetailsComponent,
    leave: true,
    auth: {
      permission: 'JobAdmin.Jobs.CREATE_QUICK_JOB',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'jobs/:jobId/spec',
    component: JobSpecDetailsComponent,
    init: JobSpecBusinessService,
    leave: true,
    auth: {
      permission: 'JobAdmin.JobSpecifications.ANY',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'jobs/:jobId/spec/new',
    component: JobSpecDetailsComponent,
    init: JobSpecBusinessService,
    leave: true,
    auth: {
      permission: 'JobAdmin.JobSpecifications.CREATE_EDIT',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'jobs/dpp/:jobId',
    component: JobDppDetailsContainerComponent,
    init: JobDPPBusinessService,
    auth: {
      permission: ['JobAdmin.JobDetails.VIEW', 'JobAdmin.JobDetails.EDIT'],
      applicationView: APPLICATION_VIEW_OFFICE,
    },
    children: [
      createRoute({
                    component: JobDppDetailsGeneralTabComponent,
                    leave: true,
                    path: 'general',
                    init: {
                      service: JobDPPBusinessService,
                      selector: 'initGeneralTabView',
                    },
                  }),
      createRoute({
                    component: JobDppDetailsLetterListTabComponent,
                    path: 'letters',
                    init: {
                      service: JobDPPBusinessService,
                      selector: 'initLettersDocsTabView',
                    },
                  }),
      createRoute({
                    component: JobDppDetailsCommunicationListTabComponent,
                    path: 'communications',
                    init: {
                      service: JobDPPBusinessService,
                      selector: 'initCommunicationListTabView',
                    },
                  }),
      createRoute({
                    component: JobDppDetailsChecklistsTabComponent,
                    path: 'checklists',
                    init: {
                      service: JobDPPBusinessService,
                      selector: 'initChecklistsTabView',
                    },
                  }),
    ],
  }),
  createRoute({
    path: 'jobs/:jobId/color-selection/new',
    component: JobCsDetailsComponent,
    init: JobCsDetailsBusinessService,
    leave: true,
    auth: {
      permission: 'JobAdmin.JobColorSelection.CREATE_EDIT',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'jobs/:jobId/color-selection',
    component: JobCsDetailsComponent,
    init: JobCsDetailsBusinessService,
    leave: true,
    auth: {
      permission: 'JobAdmin.JobColorSelection.ANY',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'job-change-orders',
    component: JobCoJobListComponent,
    init: JobCoJobListBusinessService,
    auth: {
      permission: ['JobAdmin.JobChangeOrders.LIST'],
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'job-change-orders/:jobId',
    component: JobCoListComponent,
    init: JobCoListBusinessService,
    auth: {
      permission: ['JobAdmin.JobChangeOrders.LIST'],
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'jobs/:jobId/change-orders/new',
    component: JobCoDetailsComponent,
    init: JobCoDetailsBusinessService,
    leave: true,
    auth: {
      permission: ['JobAdmin.JobChangeOrders.CREATE'],
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'jobs/:jobId/change-orders/:changeOrderId',
    component: JobCoDetailsComponent,
    init: JobCoDetailsBusinessService,
    leave: true,
    auth: {
      permission: [
        'JobAdmin.JobChangeOrders.EDIT',
        'JobAdmin.JobChangeOrders.VIEW',
      ],
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'jobs/:jobId/change-orders/:changeOrderId/invoice',
    component: JobCoDetailsComponent,
    init: JobCoDetailsBusinessService,
    leave: true,
    auth: {
      permission: [
        'JobAdmin.JobChangeOrders.EDIT',
        'JobAdmin.JobChangeOrders.VIEW',
      ],
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'jobs/:jobId/estimate',
    component: JobEstimateDetailsComponent,
    init: JobEstimateDetailsBusinessService,
    leave: true,
    auth: {
      permission: 'Estimating.JobEstimate.EDIT_VIEW',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'job-orders',
    component: JobOrderListComponent,
    init: JobOrderListBusinessService,
    auth: {
      permission: 'JobAdmin.JobOrders.LIST',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'job-orders/:jobId',
    component: JobOrderDetailsComponent,
    init: JobOrderDetailsListBusinessService,
    auth: {
      permission: 'JobAdmin.JobOrders.PRODUCE_VIEW',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'job-financials',
    component: JobFinancialsListComponent,
    init: JobFinancialsListBusinessService,
    auth: {
      permission: 'JobAdmin.Financials.LIST',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'job-color-selection',
    component: JobColorSelectionListComponent,
    init: JobCsListBusinessService,
    auth: {
      permission: 'JobAdmin.JobColorSelection.LIST',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'job-financials/:jobId',
    component: JobFinancialsComponent,
    init: JobFinancialsBusinessService,
    auth: {
      permission: 'JobAdmin.Financials.VIEW',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderJobAdminRoutingModule {
}
